import { render } from "./hrm-asset-modal.vue?vue&type=template&id=0d4f31ca"
import script from "./hrm-asset-modal.vue?vue&type=script&lang=js"
export * from "./hrm-asset-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__